export default function faqFiter () {
    document.addEventListener("DOMContentLoaded", () => {
        const searchInput = document.querySelector('input[name="faq"]')
        const searchIcon = document.querySelector('.js-section-faq__search')
        const searchIconSvg = document.querySelector('.js-section-faq__search svg')
        const input = document.querySelector(".js-section-faq__input-block input")
        const wrapper = document.querySelector(".js-section-faq__input-block")
        let timeout = null

        if (input && wrapper) {
            input.addEventListener("click", () => {
                wrapper.classList.add("section-faq__input-block--focused")
            })
            input.addEventListener("blur", () => {
                wrapper.classList.remove("section-faq__input-block--focused")
            })
        }

        function updateSearch() {
            if (timeout) clearTimeout(timeout)
            timeout = setTimeout(() => {
                sendSearchRequest()
            }, 2000)
        }

        const sendSearchRequest = () => {
            searchIconSvg.classList.add('section-faq__search-icon')
            if (input && wrapper) {
                wrapper.classList.remove("section-faq__input-block--focused")
            }

            const params = new URLSearchParams()
            if (searchInput.value) params.set("search", searchInput.value)
            const newUrl = "?" + params.toString()
            window.history.replaceState({}, "", newUrl)
            
            fetchResults(newUrl)

            if (params.toString() === "") {
                searchIconSvg.classList.remove("section-faq__search-icon")
            }
        }

        function fetchResults(url) {
            fetch(url)
                .then(response => response.text())
                .then(html => {
                    let parser = new DOMParser()
                    let doc = parser.parseFromString(html, "text/html")
                    const faqList = doc.querySelector("#faqAccordion")
                    const documentFaqList = document.querySelector("#faqAccordion")
                    documentFaqList.innerHTML = faqList.innerHTML
                })
        }

        if (searchInput) {
            searchInput.addEventListener("input", updateSearch);
            searchInput.addEventListener("keydown", (event) => {
                if (event.key === "Enter") {
                    event.preventDefault()
                    sendSearchRequest()
                }
            })
        }

        if (searchIcon) {
            searchIcon.addEventListener('click', () => sendSearchRequest())
        }
    })
}